import { Box, css, Stack, styled } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { GlobalConfirm } from '@/components/display/GlobalConfirm';
import { GlobalSnackbar } from '@/components/display/GlobalSnackbar';
import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';
import { JwtTokenType } from '@/modules/api/backend';
import { backendApiAuthenticationRefreshOptions } from '@/modules/api/backend/@tanstack/react-query.gen';

const Root = styled(Stack)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100dvh;

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      min-height: 100vh;
    }
  `,
);

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context, location }) => {
    if (!context.user || !context.ability) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
        replace: true,
      });
    }

    return {
      user: context.user,
      ability: context.ability,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AuthenticatedLayout,
  errorComponent: ({ error }) => {
    throw error;
  },
});

function AuthenticatedLayout() {
  useQuery({
    ...backendApiAuthenticationRefreshOptions({ body: { type: JwtTokenType.ACCESS } }),
    // 10 minutes
    refetchInterval: 10 * 60 * 1000,
  });
  useQuery({
    ...backendApiAuthenticationRefreshOptions({ body: { type: JwtTokenType.REFRESH } }),
    // 1 day
    refetchInterval: 24 * 60 * 60 * 1000,
  });

  return (
    <Root>
      <Header />
      <Box flex={1}>
        <Outlet />
        <GlobalSnackbar />
        <GlobalConfirm />
      </Box>
      <Footer />
    </Root>
  );
}
